import {CompoundChunk} from "./chunk/CompoundChunk"
import {ChunkObject} from "./chunk/ChunkObject"
import {ChunkBase} from "./chunk/ChunkBase"
import {Bytes} from "../haxe/io/Bytes"
import {Register} from "../genes/Register"

export const EmptyChunk = Register.global("$hxClasses")["tink._Chunk.EmptyChunk"] = 
class EmptyChunk extends Register.inherits(ChunkBase) {
	new() {
	}
	getLength() {
		return 0;
	}
	blitTo(target, offset) {
	}
	toString() {
		return "";
	}
	toBytes() {
		return EmptyChunk.EMPTY;
	}
	static get __name__() {
		return "tink._Chunk.EmptyChunk"
	}
	static get __interfaces__() {
		return [ChunkObject]
	}
	static get __super__() {
		return ChunkBase
	}
	get __class__() {
		return EmptyChunk
	}
}


EmptyChunk.EMPTY = new Bytes(new ArrayBuffer(0))
export const Chunk_Impl_ = Register.global("$hxClasses")["tink._Chunk.Chunk_Impl_"] = 
class Chunk_Impl_ {
	static concat(this1, that) {
		return CompoundChunk.cons(this1, that);
	}
	static get __name__() {
		return "tink._Chunk.Chunk_Impl_"
	}
	get __class__() {
		return Chunk_Impl_
	}
}


Register.createStatic(Chunk_Impl_, "EMPTY", function () { return new EmptyChunk() })